import { css } from "@emotion/react";
// import logoImage from "../../../static/evalight.png";

/**
 * Logo Component
 * - Fixed: Blue color transformation for Orange/Pink icon.
 * - Improved: Contrast and Sharpness.
 */
export function Logo(props: { size?: number }) {
  const { size = 36 } = props;
  return (
    <div
      css={css`
        width: ${size}px;
        height: ${size}px;
        background-color: #005f56;
        color: #ffffff;
        font-weight: 800;
        font-size: 18px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        box-shadow: 0 2px 4px rgba(0, 95, 86, 0.2);
      `}
    >
      E
    </div>
  );
}

/**
 * LogoText Component
 * - Premium Tech Brand text with Enterprise subtitle
 */
export function LogoText({ className }: { className?: string }) {
  return (
    <div
      className={className}
      css={css`
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-family: var(--ac-premium-font-family);
        padding-bottom: 2px;
        margin-left: 10px;
      `}
    >
      <span
        css={css`
          font-weight: 700;
          font-size: 19px;
          color: var(--global-text-color-900, #000000);
          line-height: 1.1;

          body.theme--dark & {
            color: #ffffff;
          }
        `}
      >
        Evalight
      </span>
      <span
        css={css`
          font-size: 10.5px;
          font-weight: 500;
          color: #557872;
          text-transform: uppercase;
          letter-spacing: 0.6px;
          margin-top: 2px;
          white-space: nowrap;

          body.theme--dark & {
            color: rgba(255, 255, 255, 0.6);
          }
        `}
      >
        Enterprise Dashboard
      </span>
    </div>
  );
}